module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pricing"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "big-slogan-blue"
  }, [_vm._v(_vm._s(_vm.$t("pricing.pageHeader")))]), _vm._v(" "), _c('h2', {
    staticClass: "mb-50"
  }, [_vm._v(_vm._s(_vm.$t("pricing.pageSubtitle")))])]), _vm._v(" "), _c('div', {
    staticClass: "container pricing"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "jumbotron price-pre-launch domore-blue-2-lighter-bgd"
  }, [_c('h4', {
    staticClass: "crowd-or-rais"
  }, [_c('span', {
    staticClass: "domore-blue-2"
  }, [_vm._v(_vm._s(_vm.$t("pricing.optionOneTitle")))])]), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t("pricing.optionOneFee"))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t("pricing.optionOneDescription")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "jumbotron price-crow domore-blue-1-light-bgd"
  }, [_vm._m(0), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("5%"), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t("pricing.platformFees")))])]), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("3% + 30c"), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t("pricing.platformFees")))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "jumbotron price-rais domore-yellow-light-bgd"
  }, [_vm._m(1), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("0%"), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t("pricing.platformFees")))])]), _vm._v(" "), _c('h3', {
    staticClass: "text-center"
  }, [_vm._v("3% + 30c"), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t("pricing.platformFees")))])])])])]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t("pricing.payPalRates")))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-lg button-center-crowd mb-50",
    attrs: {
      "href": "start-campaign.html",
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t("pricing.startButton")))])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid pricing-options domore-blue-1-light-bgd"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "text-center mt-50 mb-30"
  }, [_vm._v(_vm._s(_vm.$t("crowdfundingOptions.title")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4 col-md-offset-2"
  }, [_c('h3', {
    staticClass: "text-center mb-50"
  }, [_vm._v(_vm._s(_vm.$t("crowdfundingOptions.optionOneTitle"))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t("crowdfundingOptions.optionOneDescription")))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h3', {
    staticClass: "text-center mb-50"
  }, [_vm._v(_vm._s(_vm.$t("crowdfundingOptions.optionTwoTitle"))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.$t("crowdfundingOptions.optionTwoDescription")))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "container payments"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h2', {
    staticClass: "text-center mt-50 mb-30"
  }, [_vm._v(_vm._s(_vm.$t("pricing.title")))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('h5', {
    staticClass: "text-center mb-50"
  }, [_c('i', {
    staticClass: "fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('br'), _vm._v(_vm._s(_vm.$t("pricing.paymentOne")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h5', {
    staticClass: "text-center mb-50"
  }, [_c('i', {
    staticClass: "fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('br'), _vm._v(_vm._s(_vm.$t("pricing.paymentTwo")))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('h5', {
    staticClass: "text-center mb-50"
  }, [_c('i', {
    staticClass: "fa fa-star",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('br'), _vm._v(_vm._s(_vm.$t("pricing.currencies")))])])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-lg button-center-crowd mb-50",
    attrs: {
      "href": "start-campaign.html",
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.$t("howItWorks.startCampaignButton")))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "crowd-or-rais"
  }, [_c('span', {
    staticClass: "domore-blue-1"
  }, [_vm._v("CROWDFUNDING")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h4', {
    staticClass: "crowd-or-rais"
  }, [_c('span', {
    staticClass: "domore-yellow"
  }, [_vm._v("FUNDRAISING")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-745ba5c8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/About/Pricing.vue
// module id = 819
// module chunks = 1